import { h } from 'preact';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Skeleton from '@mui/material/Skeleton';

export default function LazyAdminUserRecord(_props) {
  return (
    <TableRow hover>
      <TableCell>
        <Skeleton width={200} />
      </TableCell>
      <TableCell>
        <Skeleton width={300} />
      </TableCell>
      <TableCell>
        <Skeleton width={100} />
      </TableCell>
      <TableCell>
        <Skeleton width={100} />
      </TableCell>
    </TableRow>
  );
}
